<template>
  <div  class="cx-card cx-margin-overview" v-if="marginOverview">
    <div class="scoped-header">
      <CxMarginOverviewIcon /> 
      <div class="font-weight-bold scoped-head-text">{{ $t("Webportal.Cx.MarginOverview") }}</div>
      
      <b-dropdown v-if="marginOverview"
                  size="sm" 
                  :text="selectedText" 
                  v-model="selectedItem" 
                  :disabled="isDisabled"
                  class="scoped-border">
        <b-dropdown-header id="dropdown-header-label">
          {{ $t('Webportal.SelectYear') }}:
        </b-dropdown-header>
        <b-dropdown-item-button v-for="(option) in items" 
                                :key="option"
                                @click="selectedItem = option"
                                aria-describedby="dropdown-header-label">
          {{ option }}
        </b-dropdown-item-button>
      </b-dropdown>
    </div>

    <table class="scoped-table">
      <thead>
        <tr>
          <th scope="col" class="col1">{{ $t('Webportal.CX.MarginModule') }}:</th>
          <th scope="col">{{ $t('Webportal.CX.ReachedMarginPoints') }}</th>
          <th scope="col">% {{ $t('Webportal.CX.Missed') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ $t('Webportal.CX.LeadManagement') }}</td>
          <td>{{ getLeadManagement }}</td>
          <td>{{ getLeadManagementMissed }}</td>
        </tr>
        <tr>
          <td>{{ $t('Webportal.CX.CustomerFirst') }} {{ $t('Webportal.Dashboard.NPS') }} {{ $t('Webportal.CX.RedFlagClosing') }}</td>
          <td>{{ getClosedRedFlags }}</td>
          <td>{{ getClosedRedFlagsMissed }}</td>
        </tr>
        <tr>
          <td>{{ $t('Webportal.CX.ContactQuota') }}</td>
          <td>{{ getContactQuota }}</td>
          <td>{{ getContactQuotaMissed }}</td>
        </tr>
        <tr>
          <td>{{ $t('Webportal.Dashboard.NetPromoterScore') }}</td>
          <td>{{ getNetPromoterScore }}</td>
          <td>{{ getNetPromoterScoreMissed }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="scoped-bottom">
          <td>{{ $t('Webportal.Dashboard.Total') }}</td>
          <td>{{ getTotalMarginScores }}</td>
          <td>{{ getTotalMarginScoresMissed }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import CxMarginOverviewIcon from './CxMarginOverviewIcon.vue';

export default {
  components: {
    CxMarginOverviewIcon
  },
  
  props: {
    marginOverview:         { type: Object, required: true },
    theme:                  { type: String, default: () => 'light' },
  },
  
  data() {
    return {
      isLoading: true,
      isDisabled: false,
      items: [],
      selectedItem: undefined
    };
  },

  mounted() {
    this.isLoading = false;
    if (this.marginOverview) {
      this.items = this.initializeYears();
      if (this.items.length > 0) {
        this.selectedItem = this.items[this.items.length - 1];
      }
    }
  },

  methods: {
    initializeYears() {
      let data = [];
      Object.values(this.marginOverview).forEach(items => {
        for (let value of items) {
          if (!data.some(item => item.quarter === value.Quarter && item.year === value.Year))
            data.push({ quarter: value.Quarter, year: value.Year });
        }
      });

      return _.orderBy(data, ['year', 'quarter'], ['asc', 'asc'])
        .map(item => `Q${item.quarter}/${item.year}`);
    },

    getValues(items) {
      if (this.selectedItem === undefined || this.selectedItem === '')
        return '-';

      let quarter = Number(this.selectedItem[1]);
      let year = Number(this.selectedItem.substring(3));
      let data = items.find(item => item.Quarter === quarter && item.Year === year);
      if (data)
        return `${data.Margin} / ${data.PossibleMargin}`;
      return '- / -';
    },

    getMisses(items) {
      if (this.selectedItem === undefined || this.selectedItem === '')
        return '-';

      let quarter = Number(this.selectedItem[1]);
      let year = Number(this.selectedItem.substring(3));
      let data = items.find(item => item.Quarter === quarter && item.Year === year);
      if (data)
        return `${data.MissingPercent}`;
      return '-';
    }
  },

  computed: {
    selectedText() {
      return `${this.selectedItem}`;
    },

    getLeadManagement() {
      return this.getValues(this.marginOverview.LeadManagement);
    },
    getLeadManagementMissed() {
      return this.getMisses(this.marginOverview.LeadManagement);
    },
    getClosedRedFlags() {
      return this.getValues(this.marginOverview.ClosedRedFlags);
    },
    getClosedRedFlagsMissed() {
      return this.getMisses(this.marginOverview.ClosedRedFlags);
    },
    getContactQuota() {
      return this.getValues(this.marginOverview.ContactQuota);
    },
    getContactQuotaMissed() {
      return this.getMisses(this.marginOverview.ContactQuota);
    },
    getNetPromoterScore() {
      return this.getValues(this.marginOverview.NetPromoterScore);
    },
    getNetPromoterScoreMissed() {
      return this.getMisses(this.marginOverview.NetPromoterScore);
    },
    getTotalMarginScores() {
      return this.getValues(this.marginOverview.TotalMarginScores);
    },
    getTotalMarginScoresMissed() {
      return this.getMisses(this.marginOverview.TotalMarginScores);
    }


  }
}
</script>

<style scoped>
.scoped-border {
  border: 1.5px solid var(--color-primary);
  border-radius: 0.25rem;
}
.scoped-header {
  display: grid;
  grid-template-columns: 1fr 4fr 2fr;
  margin: 0.5rem;
}
 
td:first-child {
  /* white-space: nowrap; */
  white-space: break-spaces;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 0;
}
td:nth-last-child(2) {
  text-align: center;
  padding-right: 1.5rem;
}
td:last-child {
  text-align: right;
  padding-right: 1.5rem;
}
th:last-child, th:nth-last-child(2) {
  text-align: center;
}

table tbody tr:nth-child(odd) {
  background-color: #222;
}

.col1 {
  width: 50%;
}

.scoped-table {
  display: table;
  width: calc(100% - 1rem);
  margin: 0.5rem;
}

.scoped-bottom {
  font-weight: bold;
}

.scoped-table thead tr {
  border-bottom: 2px solid var(--color-primary);
}
.scoped-table tfoot tr {
  border-top: 2px solid var(--color-primary);
}
.scoped-table tbody td:first-child {
  border-right: 2px solid var(--color-primary);
}
.scoped-head-text {
  margin-top: 0.25rem;
}
</style>